export const categories = [
  {
    id: 'living-room',
    name: 'Living Room',
    image: 'https://images.pexels.com/photos/17248117/pexels-photo-17248117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Elegant living room furniture'
  },
  {
    id: 'sofas',
    name: 'Sofas & Sectionals',
    image: 'https://images.pexels.com/photos/33049544/pexels-photo-33049544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Premium comfort seating'
  },
  {
    id: 'dining',
    name: 'Dining Room',
    image: 'https://images.pexels.com/photos/2995012/pexels-photo-2995012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Luxurious dining sets'
  },
  {
    id: 'bedroom',
    name: 'Bedroom',
    image: 'https://images.unsplash.com/photo-1706809019104-02d83b4541ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiZWRyb29tJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3Mjg5ODc1N3ww&ixlib=rb-4.1.0&q=85',
    description: 'Restful bedroom furniture'
  },
  {
    id: 'accent-chairs',
    name: 'Accent Chairs',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&q=80&w=800',
    description: 'Statement seating pieces'
  },
  {
    id: 'coffee-tables',
    name: 'Coffee Tables',
    image: 'https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&q=80&w=800',
    description: 'Centerpiece tables'
  },
  {
    id: 'cabinets',
    name: 'Luxury Cabinets',
    image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80&w=800',
    description: 'Storage with style'
  },
  {
    id: 'office',
    name: 'Home Office',
    image: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?auto=format&fit=crop&q=80&w=800',
    description: 'Productive workspaces'
  }
];

export const products = [
  {
    id: 1,
    name: 'Milano Velvet Sectional Sofa',
    price: 4299,
    originalPrice: 5499,
    category: 'sofas',
    rating: 4.9,
    reviews: 127,
    image: 'https://images.pexels.com/photos/33049544/pexels-photo-33049544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/33049544/pexels-photo-33049544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Experience unparalleled luxury with our Milano Velvet Sectional Sofa. Crafted with premium Italian velvet and a solid oak frame, this piece brings sophisticated elegance to any living space.',
    specifications: {
      dimensions: '120" W x 95" D x 34" H',
      material: 'Italian Velvet, Solid Oak Frame',
      color: 'Charcoal Grey',
      weight: '285 lbs',
      seatHeight: '18 inches',
      armHeight: '26 inches'
    },
    care: 'Professional cleaning recommended. Vacuum regularly with soft brush attachment. Avoid direct sunlight.',
    badge: 'Best Seller',
    isNew: false,
    inStock: true
  },
  {
    id: 2,
    name: 'Astoria King Platform Bed',
    price: 3899,
    originalPrice: 4599,
    category: 'bedroom',
    rating: 4.8,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1612301988752-5a5b19021f45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiZWRyb29tJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3Mjg5ODc1N3ww&ixlib=rb-4.1.0&q=85',
    images: [
      'https://images.unsplash.com/photo-1612301988752-5a5b19021f45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiZWRyb29tJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3Mjg5ODc1N3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'The Astoria King Platform Bed combines modern minimalism with timeless elegance. Features a floating design with integrated LED ambient lighting.',
    specifications: {
      dimensions: '82" W x 86" D x 45" H',
      material: 'Walnut Veneer, Steel Base',
      color: 'Natural Walnut',
      weight: '195 lbs',
      mattressSize: 'King (76" x 80")'
    },
    care: 'Dust with soft cloth. Apply wood polish quarterly.',
    badge: null,
    isNew: true,
    inStock: true
  },
  {
    id: 3,
    name: 'Carrara Marble Dining Table',
    price: 6799,
    originalPrice: 7999,
    category: 'dining',
    rating: 5.0,
    reviews: 54,
    image: 'https://images.pexels.com/photos/2995012/pexels-photo-2995012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/2995012/pexels-photo-2995012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'A masterpiece of Italian craftsmanship, this dining table features genuine Carrara marble top with subtle grey veining atop a sculptural brass base.',
    specifications: {
      dimensions: '96" W x 42" D x 30" H',
      material: 'Carrara Marble, Brass Base',
      color: 'White/Gold',
      weight: '450 lbs',
      seatingCapacity: '8-10 guests'
    },
    care: 'Seal marble annually. Clean with pH-neutral cleaner. Use coasters and placemats.',
    badge: 'Premium',
    isNew: false,
    inStock: true
  },
  {
    id: 4,
    name: 'Vienna Accent Chair',
    price: 1899,
    originalPrice: 2299,
    category: 'accent-chairs',
    rating: 4.7,
    reviews: 156,
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'The Vienna Accent Chair is a statement piece that combines mid-century modern design with contemporary comfort. Perfect for reading nooks or living spaces.',
    specifications: {
      dimensions: '32" W x 34" D x 36" H',
      material: 'Bouclé Fabric, Walnut Legs',
      color: 'Ivory',
      weight: '45 lbs',
      seatHeight: '17 inches'
    },
    care: 'Spot clean with mild detergent. Professional cleaning recommended annually.',
    badge: 'Best Seller',
    isNew: false,
    inStock: true
  },
  {
    id: 5,
    name: 'Noir Coffee Table',
    price: 1299,
    originalPrice: 1599,
    category: 'coffee-tables',
    rating: 4.8,
    reviews: 92,
    image: 'https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1532372320572-cda25653a26d?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Sleek and modern, the Noir Coffee Table features a black marble top with dramatic white veining, supported by a geometric matte black steel frame.',
    specifications: {
      dimensions: '48" W x 26" D x 16" H',
      material: 'Nero Marquina Marble, Steel',
      color: 'Black/White',
      weight: '120 lbs'
    },
    care: 'Wipe with damp cloth. Avoid acidic substances on marble surface.',
    badge: null,
    isNew: true,
    inStock: true
  },
  {
    id: 6,
    name: 'Monaco Executive Desk',
    price: 2899,
    originalPrice: 3499,
    category: 'office',
    rating: 4.9,
    reviews: 67,
    image: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1593642532400-2682810df593?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Command your workspace with the Monaco Executive Desk. Features integrated cable management, soft-close drawers, and a hand-finished leather writing surface.',
    specifications: {
      dimensions: '72" W x 36" D x 30" H',
      material: 'Walnut, Italian Leather',
      color: 'Dark Walnut',
      weight: '175 lbs',
      drawers: '6 soft-close drawers'
    },
    care: 'Condition leather every 6 months. Dust wood surfaces regularly.',
    badge: 'Best Seller',
    isNew: false,
    inStock: true
  },
  {
    id: 7,
    name: 'Versailles Display Cabinet',
    price: 3499,
    originalPrice: 4199,
    category: 'cabinets',
    rating: 4.6,
    reviews: 43,
    image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600585152220-90363fe7e115?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Showcase your prized possessions in the Versailles Display Cabinet. Features adjustable glass shelves, interior LED lighting, and antique brass hardware.',
    specifications: {
      dimensions: '48" W x 18" D x 78" H',
      material: 'Oak, Tempered Glass',
      color: 'Natural Oak',
      weight: '165 lbs',
      shelves: '4 adjustable glass shelves'
    },
    care: 'Clean glass with streak-free cleaner. Dust wood surfaces weekly.',
    badge: null,
    isNew: false,
    inStock: true
  },
  {
    id: 8,
    name: 'Santorini Outdoor Sofa',
    price: 4599,
    originalPrice: 5299,
    category: 'living-room',
    rating: 4.8,
    reviews: 78,
    image: 'https://images.pexels.com/photos/17248117/pexels-photo-17248117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/17248117/pexels-photo-17248117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Bring resort-style luxury to your living room with the Santorini Sofa. Features deep seating, premium fabric, and a contemporary low-profile design.',
    specifications: {
      dimensions: '98" W x 40" D x 32" H',
      material: 'Performance Fabric, Teak Frame',
      color: 'Sand Beige',
      weight: '210 lbs',
      seatDepth: '24 inches'
    },
    care: 'Fabric is stain-resistant. Clean with mild soap and water.',
    badge: 'Premium',
    isNew: false,
    inStock: true
  },
  {
    id: 9,
    name: 'Luxe Bedside Table Set',
    price: 899,
    originalPrice: 1199,
    category: 'bedroom',
    rating: 4.7,
    reviews: 112,
    image: 'https://images.unsplash.com/photo-1706809019104-02d83b4541ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiZWRyb29tJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3Mjg5ODc1N3ww&ixlib=rb-4.1.0&q=85',
    images: [
      'https://images.unsplash.com/photo-1706809019104-02d83b4541ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiZWRyb29tJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3Mjg5ODc1N3ww&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Complete your bedroom with this elegant pair of bedside tables. Features wireless charging pads and soft-close drawers.',
    specifications: {
      dimensions: '24" W x 18" D x 22" H (each)',
      material: 'Lacquered Wood, Brass Handles',
      color: 'Matte White',
      weight: '35 lbs each',
      quantity: 'Set of 2'
    },
    care: 'Wipe with damp cloth. Avoid harsh chemicals.',
    badge: null,
    isNew: true,
    inStock: true
  },
  {
    id: 10,
    name: 'Atlas Dining Chair Set',
    price: 2199,
    originalPrice: 2799,
    category: 'dining',
    rating: 4.9,
    reviews: 84,
    image: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&q=80&w=800',
      'https://images.pexels.com/photos/2995012/pexels-photo-2995012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    ],
    description: 'Elevate your dining experience with the Atlas Chair Set. Ergonomically designed for comfort during long dinner parties.',
    specifications: {
      dimensions: '20" W x 22" D x 34" H (each)',
      material: 'Full-grain Leather, Steel',
      color: 'Cognac',
      weight: '18 lbs each',
      quantity: 'Set of 4'
    },
    care: 'Condition leather every 3 months. Wipe steel with dry cloth.',
    badge: 'Best Seller',
    isNew: false,
    inStock: true
  },
  {
    id: 11,
    name: 'Parisian Console Table',
    price: 1599,
    originalPrice: 1999,
    category: 'living-room',
    rating: 4.6,
    reviews: 56,
    image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1600585152220-90363fe7e115?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'The Parisian Console Table makes a stunning entryway statement. Features hand-applied gold leaf detailing and a mirror-finish top.',
    specifications: {
      dimensions: '54" W x 16" D x 32" H',
      material: 'Mahogany, Gold Leaf, Mirror',
      color: 'Black/Gold',
      weight: '85 lbs'
    },
    care: 'Dust gently. Avoid placing hot items directly on mirror surface.',
    badge: null,
    isNew: false,
    inStock: true
  },
  {
    id: 12,
    name: 'Nordic Lounge Chair',
    price: 2499,
    originalPrice: 2999,
    category: 'accent-chairs',
    rating: 4.8,
    reviews: 93,
    image: 'https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?auto=format&fit=crop&q=80&w=800',
    images: [
      'https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?auto=format&fit=crop&q=80&w=800'
    ],
    description: 'Inspired by Scandinavian design, the Nordic Lounge Chair offers exceptional comfort with clean, modern lines. Perfect for any contemporary space.',
    specifications: {
      dimensions: '30" W x 32" D x 38" H',
      material: 'Wool Blend, Solid Ash',
      color: 'Charcoal Grey',
      weight: '52 lbs',
      seatHeight: '16 inches'
    },
    care: 'Vacuum regularly. Professional cleaning recommended for stains.',
    badge: 'New Arrival',
    isNew: true,
    inStock: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'New York, NY',
    rating: 5,
    text: "The sofa quality is outstanding and looks stunning in our living room. The craftsmanship exceeded my expectations.",
    product: 'Milano Velvet Sectional'
  },
  {
    id: 2,
    name: 'James Anderson',
    location: 'Los Angeles, CA',
    rating: 5,
    text: "Beautiful craftsmanship and very comfortable furniture. Our dining room has never looked better.",
    product: 'Carrara Marble Dining Table'
  },
  {
    id: 3,
    name: 'Emily Chen',
    location: 'Chicago, IL',
    rating: 5,
    text: "Fast shipping and the bed is absolutely gorgeous. The quality of materials is exceptional.",
    product: 'Astoria King Platform Bed'
  },
  {
    id: 4,
    name: 'Michael Roberts',
    location: 'Miami, FL',
    rating: 5,
    text: "Premium quality that matches the price. These accent chairs transformed our home office.",
    product: 'Vienna Accent Chair'
  }
];

export const brandInfo = {
  name: 'Bright Vista',
  tagline: 'Luxury Furniture Designed for Modern Living',
  email: 'support@brightvista.store',
  phone: '+1-888-128-5663',
  address: '88 A 21st St #4692, New York, NY 30265, United States',
  hours: 'Mon - Fri: 9AM - 6PM EST',
  socials: {
    instagram: '#',
    facebook: '#',
    pinterest: '#',
    twitter: '#'
  }
};
